import React from 'react'
import './index.scss'
import { useFormContext, Controller } from 'react-hook-form'
import Select, { ActionMeta, MultiValue } from 'react-select'
import clsx from 'clsx'
import FieldErrorSectionForm from '@App/kit/fields/FieldErrorSectionForm'
import { DropdownFormFieldProps } from '@App/forms/common/dropdown-form-field'
import { SelectOption } from '@Components/Selectors/Select'

export const selectAllValue = 'Select all'

const MultiDropdownForm = (props: DropdownFormFieldProps) => {
    const { control } = useFormContext()
    const {
        name,
        options,
        mainColor = true,
        label,
        assistiveText,
        placeholder,
        className,
        assistiveTextFunction,
        showLabelOnSelect = true,
        registerOptions,
        isPhoneType = false,
        defaultValue,
        assistiveTextVisibility,
        isClearable,
    } = props

    const required = !!registerOptions && !!registerOptions.required
    const displayAssistiveText = assistiveText ?? (assistiveTextFunction ? assistiveTextFunction(required) : undefined)
    const theDefaultValue = defaultValue ? defaultValue : ''

    const getSelectedValue = (value: string[]) => {
        if (value.some((val) => val === selectAllValue)) {
            return options.filter((opt) => opt.value !== selectAllValue)
        } else {
            return options.filter((opt) => value.some((val) => val === opt.value))
        }
    }

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={theDefaultValue}
            rules={registerOptions}
            render={({ field: { value, onChange, onBlur, ref }, fieldState }) => {
                const outerDivClassNames = clsx(
                    'dropdown-multi-form-component',
                    mainColor ? 'main-color-set' : 'second-color-set',
                    className,
                    !!fieldState.error && 'error',
                    isPhoneType && 'phone-code-form-type'
                )

                const selectedValue = getSelectedValue(value)

                const onChangeWrapper = (newValues: MultiValue<SelectOption>, actionMeta: ActionMeta<SelectOption>) => {
                    const valueArray = newValues.map((newValue) => newValue.value)
                    onChange(valueArray)
                }

                return (
                    <>
                        <div className={outerDivClassNames}>
                            {!!value && !!label && showLabelOnSelect && (
                                <label className="dropdown-multi-form-label" htmlFor={name}>
                                    {label}
                                </label>
                            )}
                            <div className="select-multi-form-component">
                                <Select
                                    inputId={name}
                                    name={name}
                                    key={`select-${name}-${value}`}
                                    ref={ref}
                                    options={options}
                                    placeholder={placeholder ? placeholder : label}
                                    value={selectedValue}
                                    onBlur={onBlur}
                                    onChange={onChangeWrapper}
                                    classNamePrefix="react-multi-select"
                                    isClearable={!!isClearable}
                                    isMulti
                                />
                            </div>
                            <FieldErrorSectionForm
                                name={name}
                                assistiveText={displayAssistiveText}
                                visibility={assistiveTextVisibility}
                                required={required}
                            />
                        </div>
                    </>
                )
            }}
        />
    )
}

export default MultiDropdownForm
